import { GLTFData } from 'scripts/animations/three/types/gltf';
import { useGLTF } from '@react-three/drei';
import { BarMaterial, BarSecondaryMaterial, PrimaryMaterial } from './common/materials';

import ModelUrl from 'assets/gl/home/experiences/support.glb?url';

type Props = {
    final?: boolean;
};

type SupportGLTF = GLTFData<
    'Torus'
    | 'Connect'
    | 'Connect1'
    | 'Torus1_3'
    | 'Torus1_2_1'
    | 'Torus1_1'
    | 'Torus1_0'
>;

export const Support = (props: Props) => {
    const { nodes } = useGLTF(ModelUrl) as SupportGLTF;

    const { final } = props;

    return (
        <group name="Support" position={[0, 0, -0.1]}>
            <group name="support_2" scale={final ? 1 : 0}>
                <mesh
                    name="Torus"
                    geometry={nodes.Torus.geometry}
                    material={PrimaryMaterial}
                    castShadow
                    receiveShadow
                    position={[-0.01, 0.03, 0]}
                    rotation={[-Math.PI / 2, 0, 0]}
                    scale={1.37}
                >
                    <mesh
                        name="Connect"
                        geometry={nodes.Connect.geometry}
                        material={BarSecondaryMaterial}
                        castShadow
                        receiveShadow
                        position={[0, -0.01, 0]}
                        scale={1.02}
                    />
                    <mesh
                        name="Connect1"
                        geometry={nodes.Connect1.geometry}
                        material={PrimaryMaterial}
                        castShadow
                        receiveShadow
                        position={[0, -0.03, 0]}
                    />
                </mesh>
                <group name="Cloner" position={[-0.01, 0.03, 0]} rotation={[-Math.PI / 2, 0, 0]} scale={1.37}>
                    <mesh
                        name="Torus1_3"
                        geometry={nodes.Torus1_3.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[0, 0, 0]}
                        rotation={[0, 1.57, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Torus1_2_1"
                        geometry={nodes.Torus1_2_1.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[0, 0, 0]}
                        rotation={[-Math.PI, 0, -Math.PI]}
                        scale={1}
                    />
                    <mesh
                        name="Torus1_1"
                        geometry={nodes.Torus1_1.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[0, 0, 0]}
                        rotation={[0, -1.57, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Torus1_0"
                        geometry={nodes.Torus1_0.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                    />
                </group>
            </group>
        </group>
    );
};
